
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericSlowOutlined as ObiVesselGenericSlowOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-slow-outlined.js';
 
 
 

 
 export const ObiVesselGenericSlowOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-slow-outlined',
   elementClass: ObiVesselGenericSlowOutlinedElement,
   events: {
     
   }
  });
 
 